import { BranchEnum } from "commons/enum/branch-enum";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IAddEmployee } from "mobx-stores/_models/employee/employee";
import { getLabelOfBranch } from "pages/stella-inspection-note/share";
import { number, string } from "yup";
import {
  searchDepartmentTypeOptions,
  searchGenderOptions,
} from "./auto-complete-options";
export const employeeFormSchema = (): ObjectSchemaType<IAddEmployee> => ({
  code: {
    type: InputType.text,
    gridSize: 6,
    label: "Mã Nhân Viên",
    validattionYupSchema: string().required().max(50),
  },
  fullName: {
    type: InputType.text,
    gridSize: 6,
    label: "Họ Và Tên",
    validattionYupSchema: string().required().max(255),
  },
  departmentTypeId: {
    type: InputType.autoComplete,
    gridSize: 6,
    label: "Bộ Phận/ Khâu SX",
    validattionYupSchema: string().required(),
    metaData: {
      searchOptionItemsAsync: searchDepartmentTypeOptions,
    },
  },
  position: {
    type: InputType.text,
    gridSize: 6,
    label: "Chức Vụ",
    validattionYupSchema: string().max(50),
  },
  level: {
    type: InputType.text,
    gridSize: 6,
    label: "Cấp Bậc",
    validattionYupSchema: string().max(50),
  },
  qualification: {
    type: InputType.text,
    gridSize: 6,
    label: "Trình Độ",
    validattionYupSchema: string().max(50),
  },
  gender: {
    type: InputType.autoComplete,
    gridSize: 6,
    label: "Giới Tính",
    validattionYupSchema: number(),
    metaData: {
      searchOptionItemsAsync: searchGenderOptions,
    },
  },
  branch: {
    type: InputType.select,
    gridSize: 6,
    label: "Chi Nhánh",
    validattionYupSchema: string().max(255),
    optionItems: [
      {
        label: getLabelOfBranch(BranchEnum.CuChi),
        value: BranchEnum.CuChi,
      },
      {
        label: getLabelOfBranch(BranchEnum.TaUyen),
        value: BranchEnum.TaUyen,
      },
    ],
  },
  note: {
    type: InputType.text,
    gridSize: 12,
    label: "Ghi Chú",
    validattionYupSchema: string().max(1024),
  },
});
